import i18n from "i18next";
import ICU from "i18next-icu";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { resources } from "./locales";
import { Language, Languages, Translations } from "./types";

export const SupportedLanguages: Language[] = [
  { languageCode: Languages.EN, languageName: "🇬🇧 English" },
  { languageCode: Languages.DE, languageName: "🇩🇪 Deutsch" },
  { languageCode: Languages.ES, languageName: "🇪🇸 Español" },
  { languageCode: Languages.FR, languageName: "🇫🇷 Français" },
  { languageCode: Languages.PL, languageName: "🇵🇱 Polski" },
  { languageCode: Languages.NB, languageName: "🇳🇴 Norsk" },
  { languageCode: Languages.SV, languageName: "🇸🇪 Svenska" },
];

i18n
  .use(ICU)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: Languages.EN,
    supportedLngs: Object.values(Languages),
    interpolation: {
      escapeValue: false, // React sam escapuje
    },
    load: "languageOnly",
    nonExplicitSupportedLngs: true,
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      convertDetectedLanguage: (lng: string) => lng.split("-")[0],
    },
    defaultNS: Translations.GLOBAL,
    ns: Object.values(Translations),
    nsSeparator: ":",
  });

export default i18n;
